<template>
    <div class="company">
        <div class="company-des">
            <div class="company-des-top">
                <span class="company-name fl" :title="firmArchives.secuName">{{firmArchives.secuNameAbbr}}</span>
                <el-button class="qualification-query fl">资质查询</el-button>
                <ul class="company-tabs fl">
                    <li>{{firmArchives.manageFundType}}</li>
                    <li>{{firmArchives.firmType}}</li>
                </ul>
                <el-button class="attention fr" @click="attentionAdd">
                    <span v-if="firmArchives.isAttention">已关注</span>
                    <span v-else><i class="el-icon-plus"></i> 关注</span>
                </el-button>
            </div>
            <table class="company-des-table fl">
                <tr>
                    <td>成立日期：<strong>{{firmArchives.createDate}}</strong></td>
                    <td>官方网站：<a class="line_one" style="max-width: 260px;display: inline-block;" :href="firmArchives.webSite" target="_blank">{{firmArchives.webSite}}</a></td>
                </tr>
                <tr>
                    <td>管理规模：<strong>{{firmArchives.assetRange}}</strong></td>
                    <td>注册/实缴资本：<strong>{{firmArchives.regCapital}}/{{firmArchives.actulCapital}}</strong></td>
                </tr>
                <tr>
                    <td>员工人数：<strong>{{firmArchives.employeeNum}}</strong></td>
                    <td>核心人物：<strong>{{firmArchives.keyPerson}}</strong></td>
                </tr>
                <tr>
                    <td>所在城市：<strong>{{firmArchives.officeProv}}</strong></td>
                    <td>备案号：<strong>{{firmArchives.regNum}}</strong></td>
                </tr>
            </table>
            <dl class="company-des-dl fl">
                <dt>产品构成：</dt>
                <dd v-for="(item,ind) in productList" :key="ind+'pr'">{{item.name}}：{{item.value}}</dd>
            </dl>
            <div class="company-des-pie"><chart :option="optionCpgc" id="cpgc"></chart></div>
        </div>
        <el-tabs v-model="activeName" type="border-card" class="tabs-card-one">
            <el-tab-pane label="产品列表" name="first">
                <span class="fund-name">{{productTabFirst.name}}</span>
                <el-form class="form-one mt10" label-position="left" label-width="120px">
                    <el-form-item label="单位净值走势：">
                        <el-radio-group v-model="productTabFirstTime" class="radio-btnt">
                            <el-radio-button v-for="(item) in productTabFirstTimeList" :key="item.id" :label="item.name" :value="item.name"></el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <div style="width:100%;height:400px;"><chart :option="optionJzzs" id="jzzs"></chart></div>
                <el-form class="form-one mt10">
                    <el-form-item>
                        <el-radio-group v-model="productTabState" @change="productTabStateChange">
                            <el-radio label="1">运行中</el-radio>
                            <el-radio label="2">已清算</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <el-table :data="productTab" class="table-one"
                          @sort-change="changeSort"
                          :default-sort="{prop:'dealDate', order: 'descending'}"
                >
                    <el-table-column label="序号" type="index"></el-table-column>
                    <el-table-column label="产品名称" prop="secuNameAbbr" width="200">
                        <template slot-scope="scope">
                            <a class="line_one mainColor" :href="'#/product?code='+scope.row.innerCode" target="_blank" :title="scope.row.secuNameAbbr">{{scope.row.secuNameAbbr}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column label="投资策略" prop="primaryType"></el-table-column>
                    <el-table-column label="成立日期" prop="createDate" sortable="custom" :sort-orders="['ascending', 'descending']"></el-table-column>
                    <el-table-column label="净值日期" prop="dealDate" sortable="custom" :sort-orders="['ascending', 'descending']"></el-table-column>
                    <el-table-column label="今年以来" prop="thisYearYield" sortable="custom" :sort-orders="['ascending', 'descending']">
                        <template slot-scope="scope">
                            <span v-if="scope.row.thisYearYield==null||scope.row.thisYearYield=='--'">--</span>
                            <span v-else :class="[{'rColor':scope.row.thisYearYield>0},{'gColor':scope.row.thisYearYield<0}]">{{(scope.row.thisYearYield*100).toFixed(2)}}%</span>
                            <el-tooltip class="item" effect="light" placement="right">
                                <span v-if="scope.row.thisYearYield==null||scope.row.thisYearYield=='--'" slot="content">该基金净值全部缺失，暂无收益</span>
                                <span v-else-if="scope.row.regionDate>=((new Date().getFullYear()-1) +'-12-01')&&scope.row.regionDate<=((new Date().getFullYear()-1) +'-12-31')" slot="content">指标计算区间为 {{scope.row.regionDate}} 至 {{scope.row.dealDate}}</span>
                                <span v-else-if="scope.row.regionDate>=scope.row.createDate" slot="content">该基金净值出现缺失，指标计算区间不在期望日期内，实际为 {{scope.row.regionDate}} 至 {{scope.row.dealDate}}</span>
                                <span v-else slot="content">该基金为今年以后成立，指标计算区间实际为 {{scope.row.regionDate}} 至 {{scope.row.dealDate}}</span>
                                <img v-if="scope.row.regionDate>=((new Date().getFullYear()-1) +'-12-01')&&scope.row.regionDate<=((new Date().getFullYear()-1) +'-12-31')" src="@/assets/images/tip1.png" class="img-tip">
                                <img v-else src="@/assets/images/tip2.png" class="img-tip">
                            </el-tooltip>
                       </template>
                    </el-table-column>
                    <el-table-column label="成立以来" prop="totalYield" sortable="custom" :sort-orders="['ascending', 'descending']">
                        <template slot-scope="scope">
                            <span v-if="scope.row.totalYield==null||scope.row.totalYield=='--'">--</span>
                            <span v-else :class="[{'rColor':scope.row.totalYield>0},{'gColor':scope.row.totalYield<0}]">{{(scope.row.totalYield*100).toFixed(2)}}%</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="年化收益" prop="annualYield" sortable="custom" :sort-orders="['ascending', 'descending']">
                        <template slot-scope="scope">
                            <span v-if="scope.row.annualYield==null||scope.row.annualYield=='--'">--</span>
                            <span v-else :class="[{'rColor':scope.row.annualYield>0},{'gColor':scope.row.annualYield<0}]">{{(scope.row.annualYield*100).toFixed(2)}}%</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="走势图" prop=""></el-table-column> -->

                </el-table>
                <el-pagination
                        class="pagination-one mt20"
                        hide-on-single-page
                        background
                        :page-size="productTabPageNum"
                        layout="prev, pager, next"
                        @current-change="handleCurrentChange"
                        :total="productTabTotal">
                </el-pagination>
            </el-tab-pane>
            <el-tab-pane label="历史规模" name="second">
                <el-table :data="scaleTab" class="table-one">
                    <el-table-column label="日期" prop="dealDate"></el-table-column>
                    <el-table-column label="规模" prop="assetScale"></el-table-column>
                </el-table>
            </el-tab-pane>
            <!-- <el-tab-pane label="公司业绩" name="second">
                <span class="title-name">公司业绩曲线 <i class="el-icon-warning-outline"></i></span>
                <el-form class="form-one mt10" label-position="left" label-width="90px">
                    <el-form-item label="选择时间：">
                        <el-radio-group v-model="datesel">
                            <el-radio label="成立以来"></el-radio>
                            <el-radio label="最近一月"></el-radio>
                            <el-radio label="最近三月"></el-radio>
                            <el-radio label="最近半年"></el-radio>
                            <el-radio label="最近一年"></el-radio>
                            <el-radio label="今年以来"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <div style="width:100%;height:400px;" v-if="activeName==='second'"><chart :option="optionYjqx" id="yjqx"></chart></div>
                <div>
                    <span class="title-name">公司动态回撤 <i class="el-icon-warning-outline"></i></span>
                    <span class="tip-span">截止日期：2021-10-29</span>
                    <span class="tip-span">收益计算：分红再投资</span>
                </div>
                <div style="width:100%;height:400px;" v-if="activeName==='second'"><chart :option="optionDthc" id="dthc"></chart></div>
            </el-tab-pane>
            <el-tab-pane label="公司档案" name="third">公司档案<dev></dev></el-tab-pane>
            <el-tab-pane label="路演" name="fourth">路演<dev></dev></el-tab-pane>
            <el-tab-pane label="公司团队" name="fifth">公司团队<dev></dev></el-tab-pane> -->
        </el-tabs>
    </div>
</template>

<script>
    import chart from "../../components/chart";
    // import dev from "../../components/dev"
    export default {
        name: "company",
        components:{
            // dev,
            chart
        },
        data(){
            return{
                InnerCode:'',
                activeName:'first',
                firmArchives:{},
                productList:[],
                productTabState:'1', //运行状态{运行中，已清算}对应{1，2}
                productTabSort:{
                    orderBy: 1, //排序字段{成立日期，净值日期，今年以来，成立以来，年化收益}对应{0，1，2，3，4}
                    orderFlag: 0, //排序标志{倒叙，正序}对应{0，1}
                },
                productTab:[],
                productTabFirst:{name:'',code:''},
                productTabFirstTimeList:[],
                productTabFirstTime:'',
                productTabPage:1,
                productTabPageNum:10,
                productTabTotal:0,
                datesel:'成立以来',
                optionCpgc:{
                    title:{},
                    color:['#B81616','#F2C230','#BE80F2','#E48A0A','#22A1CB'],
                    tooltip: {trigger: 'item',formatter: "{b}:{d}% "},
                    legend: {orient:'vertical',top:'center',left:260,formatter:'{name}',textStyle:{color: '#333'}},
                    calculable: true,
                    series: [{
                        name: '',
                        type: 'pie',
                        radius: '60%', //饼图的半径大小
                        center: ['40%', '50%'], //饼图的位置
                        label: { //饼图图形上的文本标签
                            normal: {
                                show: true,
                                textStyle:{fontSize: 14,fontWeight:500},
                                formatter: '{d}%'
                            }
                        },
                        itemStyle:{borderColor:'#fff',borderWidth:2},
                        data:[]
                    }]
                },
                optionJzzs:{
                    graphic:[
                        {type:'text',left:'center',top:'150', z:-1,
                            style:{text: '展恒金方私募数据平台',fill:'#DDD',font:'normal 35px Microsoft YaHei'}
                        }
                    ],
                    title:{},
                    color:['#B81616','#E4DE0A','#B161CF','#01567F'],
                    legend:{
                        bottom:10,itemGap:20,textStyle:{fontSize:14,color:'#333'}
                    },
                    grid: {top:10,left: '2%',right: 35,bottom: '15%',containLabel: true},
                    xAxis:{
                        type:'category',
                        data:[],
                        axisLabel:{fontSize:12,color: "#333"},
                        axisLine:{lineStyle:{color: "#DDD"}},
                        boundaryGap: false,
                    },
                    yAxis:{
                        type:'value',
                        axisLabel: {
                            formatter:function (val){return parseFloat(val*100).toFixed(2)+'%'},
                            fontSize:14,color:'#333'
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        formatter:function (params) {

                            var htmlStr='<div class="echarts-tooltip-one"><table><tr><td>数据日期：</td><td>'+params[0].name+'</td></tr>';
                            for(let i=0;i<params.length;i++){
                                htmlStr+='<tr><td><span class="color-block" style="background:'+params[i].color+'"></span>'+params[i].seriesName+'：</td><td class="'+(params[i].value>0?'rColor':'gColor')+'">'+(params[i].value*100).toFixed(2)+'%</td></tr>';
                            }
                            htmlStr+='</table></div>';
                            return htmlStr;
                        }
                    },
                    series:[]
                },
                optionYjqx:{
                    graphic:[
                        {type:'text',left:'center',top:'center', z:-1,
                            style:{text: '展恒金方私募数据平台',fill:'#DDD',font:'normal 44px Microsoft YaHei'}
                        }
                    ],
                    title:{},
                    color:['#FF0909','#00B4FF','#FF7800'],
                    legend:{
                        bottom:'15%',itemGap:20,textStyle:{fontSize:14,color:'#333'}
                    },
                    grid: {top:'5%',left: '3%',right: '3%',bottom: '25%',containLabel: true},
                    xAxis:{
                        type:'category',
                        data:['2021-01-01','2021-01-02','2021-01-03','2021-01-04','2021-01-05','2021-01-06','2021-01-07','2021-01-08','2021-01-08'],
                        axisLabel:{fontSize:12,color: "#333"},
                        axisLine:{lineStyle:{color: "#DDD"}},
                        boundaryGap: false,
                    },
                    yAxis:{
                        type:'value',
                        axisLabel: {
                            formatter:function (val){return val*100+'%'},
                            fontSize:14,color:'#333'
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label:{backgroundColor: '#6a7985'}
                        }
                    },
                    series:[
                        {
                            name:'弘酬永泰投资',
                            type:'line',symbol:'circle',showSymbol: false,symbolSize:8,
                            data:[0,0.1345,0.0820,0.0400,0.1304,0.1175,0.1321,0.1720,0.1569],
                            areaStyle:{
                                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgba(255,9,9,0.8)'
                                    },
                                    {
                                        offset: 1,
                                        color: '#FFF'
                                    }
                                ])
                            },
                        },
                        {
                            name:'沪深300',
                            type:'line',symbol:'rect',showSymbol: false,symbolSize:8,
                            data:[0,0.0977,0.0727,0.0456,0.1296,0.1293,0.1466,0.1895,0.1576]
                        },
                        {
                            name:'私募全市场',
                            type:'line',symbol:'triangle',showSymbol: false,symbolSize:8,
                            data:[0,0.1140,0.0674,-0.0068,-0.0378,0.0461,-0.0140,0.0027,-0.0108]
                        }
                    ]
                },
                optionDthc:{
                    graphic:[
                        {type:'text',left:'center',top:'center', z:-1,
                            style:{text: '展恒金方私募数据平台',fill:'#DDD',font:'normal 44px Microsoft YaHei'}
                        }
                    ],
                    title:{},
                    color:['#FF0909','#00B4FF','#FF7800'],
                    legend:{
                        bottom:10,itemGap:20,textStyle:{fontSize:14,color:'#333'}
                    },
                    grid: {top:'10%',left: '3%',right: '3%',bottom: '15%',containLabel: true},
                    xAxis:{
                        type:'category',
                        data:['2021-01-01','2021-01-02','2021-01-03','2021-01-04','2021-01-05','2021-01-06','2021-01-07','2021-01-08','2021-01-08'],
                        axisLabel:{fontSize:12,color: "#333"},
                        axisLine:{lineStyle:{color: "#DDD"}},
                        boundaryGap: false,
                    },
                    yAxis:{
                        type:'value',
                        axisLabel: {
                            formatter:function (val){return val*100+'%'},
                            fontSize:14,color:'#333'
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label:{backgroundColor: '#6a7985'}
                        }
                    },
                    series:[
                        {
                            name:'弘酬永泰投资',
                            type:'line',symbol:'circle',showSymbol: false,symbolSize:8,
                            data:[0,-0.1345,-0.0820,-0.0400,-0.1304,-0.1175,-0.1321,-0.1720,-0.1569],
                            areaStyle:{
                                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: '#FFF'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(255,9,9,0.8)'
                                    }
                                ])
                            },
                        },
                        {
                            name:'沪深300',
                            type:'line',symbol:'rect',showSymbol: false,symbolSize:8,
                            data:[0,-0.0977,-0.0727,-0.0456,-0.1296,-0.1293,-0.1466,-0.1895,-0.1576]
                        },
                        {
                            name:'私募全市场',
                            type:'line',symbol:'triangle',showSymbol: false,symbolSize:8,
                            data:[0,-0.1140,-0.0674,-0.0068,-0.0378,-0.0461,-0.0140,-0.0027,-0.0108]
                        }
                    ]
                },
                scaleTab: [],
            }
        },
        mounted(){
            this.InnerCode=this.$route.query.code;
            this.getPrivateFirmArchives();
            this.getPrivateFirmElements();
            this.getPrivateFirmFundList();
            this.getPrivateFirmAssetScale();
        },
        watch:{
            productTabFirstTime: {
                handler (val) {
                    this.getSyChart();
                },
                deep: false
            },
        },
        methods:{
            getPrivateFirmArchives(){
                const vm=this;
                vm.$http.post(vm.$apiPath.getPrivateFirmArchives,{
                    innercode:vm.InnerCode
                }).then(res=>{
                    if(res.data.code==200){
                        vm.firmArchives=res.data.data;
                        document.title=vm.firmArchives.secuNameAbbr+'_金方数据库';
                    }
                })
            },
            getPrivateFirmElements(){
                const vm=this;
                vm.$http.post(vm.$apiPath.getPrivateFirmElements,{
                    innercode:vm.InnerCode
                }).then(res=>{
                    if(res.data.code==200){
                        let sdata=res.data.data;
                        vm.productList=sdata.productList;
                        let seriesData=[],seriesDataSum=0;
                        if(sdata.strategyList && sdata.strategyList.length>0){
                            for(let i=0;i<sdata.strategyList.length;i++){
                                seriesDataSum+=sdata.strategyList[i].value;
                            }
                            sdata.strategyList.forEach((val=>{
                                if(val.value/seriesDataSum>0.05){
                                    seriesData.push({
                                            name:val.name,
                                            value:val.value,
                                            label:{
                                                normal:{
                                                    position:'inner',
                                                    textStyle:{fontSize: 14,fontWeight:500,color:'#fff'}
                                                }}
                                        },
                                    )
                                }else{
                                    seriesData.push({
                                            name:val.name,
                                            value:val.value,
                                            label:{
                                                normal:{
                                                    position:'outside',
                                                    textStyle:{fontSize: 10,fontWeight:500,color:'inherit'}
                                                }}
                                        },
                                    )
                                }
                            }))
                        }
                        vm.optionCpgc.series[0].data=seriesData;
                    }
                })
            },
            productTabStateChange(val){
                this.productTabPage=1;
                this.getPrivateFirmFundList();
            },
            handleCurrentChange(val){
                this.productTabPage=val;
                this.getPrivateFirmFundList();
            },
            changeSort(val){
                // console.log(val)
                // orderBy: 0, //排序字段{成立日期，净值日期，今年以来，成立以来，年化收益}对应{0，1，2，3，4}
                // orderFlag: 0, //排序标志{倒叙，正序}对应{0，1}
                switch (val.order) {
                    case "ascending":
                        this.productTabSort.orderFlag=1;
                        break;
                    case "descending":
                        this.productTabSort.orderFlag=0;
                        break;
                }
                switch (val.prop) {
                    case "createDate":
                        this.productTabSort.orderBy=0;
                        break;
                    case "dealDate":
                        this.productTabSort.orderBy=1;
                        break;
                    case "thisYearYield":
                        this.productTabSort.orderBy=2;
                        break;
                    case "totalYield":
                        this.productTabSort.orderBy=3;
                        break;
                    case "annualYield":
                        this.productTabSort.orderBy=4;
                        break;
                }
                this.getPrivateFirmFundList();
            },
            getPrivateFirmFundList(){
                const vm=this;
                vm.$http.post(vm.$apiPath.GetPrivateFirmFundList,{
                    innercode:vm.InnerCode,
                    orderBy: vm.productTabSort.orderBy, //排序字段{成立日期，净值日期，今年以来，成立以来，年化收益}对应{0，1，2，3，4}
                    orderFlag: vm.productTabSort.orderFlag, //排序标志{倒叙，正序}对应{0，1}
                    ListedState: parseInt(vm.productTabState), //运行状态{运行中，已清算}对应{1，2}
                    Page: vm.productTabPage, //页数，从1开始
                    PageNum: vm.productTabPageNum //每页条数
                }).then(res=>{
                    if(res.data.code==200){
                        vm.productTab=res.data.data.dataList;
                        vm.productTabTotal=res.data.data.recordCount;
                        vm.productTabFirst.name=vm.productTab[0].secuNameAbbr;
                        vm.productTabFirst.code=vm.productTab[0].innerCode;
                        vm.productTabFirstName=vm.productTab[0].secuNameAbbr;
                        vm.getPrivateFundDatePhase();
                    }
                })
            },
            getPrivateFundDatePhase(){
                const vm=this;
                vm.$http.post(vm.$apiPath.getPrivateFundDatePhase,{
                    InnerCode:vm.productTabFirst.code
                }).then(res=>{
                    if(res.data.code==200){
                        let sdata=res.data.data;
                        vm.productTabFirstTimeList=[];
                        if(sdata.regionList && sdata.regionList.length>0){
                            sdata.regionList.forEach((val,ind)=>{
                                vm.productTabFirstTimeList.push({
                                    id:ind,
                                    name:val.region,
                                    start:val.startDate,
                                    end:val.endDate
                                })
                            })
                            vm.productTabFirstTime=vm.productTabFirstTimeList[0].name;
                        }
                    }
                })
            },
            getSyChart(){
                const vm=this;
                let startDate='',endDate='';
                vm.productTabFirstTimeList.forEach(v=>{
                    if(v.name==vm.productTabFirstTime){
                        startDate=v.start;
                        endDate=v.end;
                    }
                })
                vm.$http.post(vm.$apiPath.getPrivateFundTrendChartsEasy,{
                    InnerCode: vm.productTabFirst.code, //产品编号
                    StartDate: startDate, //走势图起始日期
                    EndDate: endDate, //走势图截止日期
                }).then(res=>{
                    if(res.data.code==200){
                        let sdata=res.data.data;
                        let seriesData=[];
                        sdata.nameList.forEach((val,ind)=>{
                            seriesData.push({
                                name:val,
                                type:'line',symbol:'circle',showSymbol: false,symbolSize:8,
                                data:sdata.dataList[ind]
                            })
                        })
                        vm.optionJzzs.xAxis.data=sdata.dateList;
                        vm.optionJzzs.series=seriesData;
                    }
                })
            },
            // 关注
            attentionAdd() {
                let vm = this
                vm.$http.post(vm.$apiPath.SetPrivateFirmCenterStatus, {
                    UserCode: vm.$commonJs.getCookie('userCode'), //用户编号
                    InnerCode: vm.InnerCode
                }).then(res => {
                    // console.log(res);
                    if (res.data.data.note) {
                        vm.getPrivateFirmArchives();
                    }
                }).catch(err => { })
            },
            getPrivateFirmAssetScale() {
                let vm = this
                vm.$http.post(vm.$apiPath.GetPrivateFirmAssetScale, {
                    InnerCode: vm.InnerCode
                }).then(res => {
                    if (res.data.code == 200) {
                        vm.scaleTab = res.data.data.dataList
                    }
                }).catch(err => { })
            },
        }
    }
</script>

<style scoped lang="less">
.company{
    &-des{
        width:1200px;height:370px;background:@whiteColor;border-radius:5px;box-shadow:@boxShadow;margin:15px auto 0;padding:0 46px;box-sizing:border-box;
        &-top{
            width:100%;height:80px;border-bottom:1px solid @borderColor;padding-top:25px;box-sizing:border-box;
            .company-name{font-size:24px;font-weight:bold;color:@mainColor;}
            .qualification-query{width:68px;height:25px;border:1px solid @cosColor;border-radius:3px;background-color:@whiteColor;font-size:12px;color:@cosColor;padding:0;margin-left:15px;margin-top:3px;}
            .company-tabs{
                margin-top:10px;margin-left:5px;
                li{float:left;font-size:14px;line-height:1;color:@color3;padding:0 15px;border-right:1px dashed @color3;}
                li:last-child{border-right:0;}
            }
            .attention{width:100px;height:30px;border-radius:3px;border:1px solid @mainColor;font-size:14px;color:@mainColor;padding:0;background: @whiteColor;}
        }
        &-table{
           width:52%;margin-top:30px;border-right:1px dashed @borderColor;
           td{
               font-size:16px;color:@color6;padding:15px 0;
               strong{color:@color3;}
               a{font-weight:bold;color:@mainColor;}
           }
        }
        &-dl{
            width:135px;margin-left:30px;margin-top:50px;color:@color3;
            dt{font-size:16px;font-weight:bold;margin-bottom:45px;}
            dd{font-size:14px;line-height:20px;}
        }
        &-pie{width:360px;height:280px;float:right;}
    }
    .tabs-card-one{
        .fund-name{font-size:24px;font-weight:bold;color:@mainColor;}
        .title-name{
            font-size:24px;font-weight:bold;color:@color3;
            i{font-size:18px;font-weight:normal;color:@color6;}
        }
        .tip-span{font-size:14px;color:@color6;margin-left:40px;}
    }
    .table-one /deep/.el-table__body-wrapper {min-height: 150px;}
}
.img-tip {position: absolute;right: 10px;top: 50%;transform: translateY(-50%);cursor: pointer;}
</style>